import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/data/content";
import { Lock, ArrowLeft } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-rc-charcoal flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm mb-8 font-mono">
          <ArrowLeft size={15} /> Back to site
        </Link>
        <div className="bg-white p-8 lg:p-10">
          <img src={BRAND.logo} alt="Ranger" className="h-9 mb-6" />
          <div className="flex items-center gap-2 font-mono text-rc-red text-xs uppercase tracking-[0.2em] mb-2">
            <Lock size={13} /> Team Login
          </div>
          <h1 className="font-heading font-black text-2xl text-rc-charcoal mb-6">Lead Management</h1>

          <form onSubmit={submit} data-testid="login-form">
            <label className="block mb-4">
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-rc-brown">Email</span>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full border border-black/15 px-4 py-3 outline-none focus:border-rc-red"
              />
            </label>
            <label className="block mb-2">
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-rc-brown">Password</span>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 w-full border border-black/15 px-4 py-3 outline-none focus:border-rc-red"
              />
            </label>
            {error && <div data-testid="login-error" className="text-rc-red text-sm mb-3">{error}</div>}
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="mt-4 w-full bg-rc-red text-white px-8 py-4 rounded-full font-bold uppercase tracking-[0.15em] text-sm hover:bg-rc-reddark transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
